module.exports = __webpack_public_path__ + "img/BINDI 4 RED.eeef1f3.svg";